import React from 'react'

import * as Fields from '../../field'

import Base from './Base';


/**
 * Dynamický export
 *
 * Všechny existující třídy obalíme
 */

/**
 * Seznam custom export tříd
 */
const exclude = ['McField'];


const toExport = {};

Object.keys(Fields).forEach(function(key) {
    if (exclude.indexOf(key) !== -1) {
        return;
    }

    const customProps = {};
    if ("Checkbox" === key) {
        customProps.check = true;
    }

    const value = Fields[key];

    class McReduxWrapp extends React.Component {
        render() {
            return <Base componentClass={value} {...this.props} {...customProps} />
        }
    }
    toExport[key] = McReduxWrapp;
});

/**
 * Přidání custom export třídy
 */
toExport['Base'] = Base;

export default toExport;
